module.exports = __webpack_public_path__ + "static/media/ic_secure.7450acba.png";